import React from "react";
import { Link } from "react-router-dom";
import { FaUtensils } from "react-icons/fa";
import { SITE_CONTENT } from "../content";

const CateringMenuPreviewSection = () => {
  const { title, subtitle, categories, liveCounterNote, ctaText } =
    SITE_CONTENT.pages.homePage.cateringMenu;

  const scrollToBooking = (e) => {
    e.preventDefault();
    const el = document.getElementById("booking-section");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="bg-[#f7f3ea] text-[#1c2e22] py-24 lg:py-32 relative overflow-hidden" id="catering-menu">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#1b4329]/10 text-[#1b4329] text-xs font-bold tracking-[0.25em] uppercase mb-4 border border-[#1b4329]/20">
            Tailored Flavours
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light font-serif leading-tight text-[#0a1a0f] mb-4">
            {title}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#D4AF37] to-[#E8A040] mx-auto mb-6 rounded-full" />
          <p className="text-[#556359] text-base sm:text-lg font-light leading-relaxed">
            {subtitle}
          </p>
        </div>

        {/* 7 Menu Categories Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-14">
          {categories.map((cat, idx) => (
            <div
              key={idx}
              className={`rounded-2xl overflow-hidden bg-white border border-[#e4dcd0] shadow-sm hover:shadow-xl hover:border-[#E8A040] transition-all duration-300 flex flex-col justify-between group ${
                idx === 6 ? "md:col-span-2 lg:col-span-3 xl:col-span-2" : ""
              }`}
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <span className="absolute bottom-3 left-4 text-white text-xs font-bold uppercase tracking-wider bg-black/40 backdrop-blur-sm px-2.5 py-1 rounded">
                  Category 0{idx + 1}
                </span>
              </div>

              <div className="p-6 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="font-semibold text-base sm:text-lg text-[#0a1a0f] mb-2 leading-snug group-hover:text-[#b8731b] transition-colors">
                    {cat.name}
                  </h3>
                </div>
                
                <div className="mt-4 pt-3 border-t border-[#f0eae0] flex items-center justify-between text-xs text-[#b8731b] font-bold uppercase tracking-wider">
                  <span>Customizable Recipe</span>
                  <FaUtensils className="w-3 h-3 opacity-60" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Live counter note & Dual CTAs */}
        <div className="p-8 rounded-3xl bg-[#092212] text-white border border-[#1b4329] shadow-xl flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="max-w-2xl">
            <span className="text-[#22c55e] text-xs font-bold tracking-widest uppercase block mb-2">
              Live Cooking Counters Available
            </span>
            <p className="text-white/85 text-base sm:text-lg leading-relaxed font-light">
              {liveCounterNote}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4 shrink-0">
            <a
              href="#booking-section"
              onClick={scrollToBooking}
              className="px-8 py-4 bg-gradient-to-r from-[#D4AF37] to-[#E8A040] text-[#0a1a0f] text-xs font-bold tracking-[0.14em] uppercase rounded-full shadow-lg hover:scale-105 transition-all duration-300"
            >
              {ctaText} &rarr;
            </a>

            <Link
              to="/menu"
              className="px-7 py-4 bg-transparent border border-white/30 text-white hover:bg-white/10 text-xs font-bold tracking-[0.14em] uppercase rounded-full transition-colors"
            >
              Explore Full Food Menu
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
};

export default CateringMenuPreviewSection;
